import React from 'react'
import NotifyAboutAdjustments from 'support/actions/shifts/NotifyAboutAdjustments'
import SubmitForApproval from 'support/actions/shifts/SubmitForApproval'
import ApproveAndPublish from 'support/actions/shifts/ApproveAndPublish'
import CreateFromTemplate from 'support/actions/shifts/CreateFromTemplate'

export default function ScheduleActions () {
  return (
    <>
      <CreateFromTemplate/>
      <NotifyAboutAdjustments/>
      <SubmitForApproval/>
      <ApproveAndPublish/>
    </>
  )
}
